import { render, staticRenderFns } from "./InspectionCard.vue?vue&type=template&id=2abf9333&scoped=true&"
import script from "./InspectionCard.vue?vue&type=script&lang=ts&"
export * from "./InspectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionCard.vue?vue&type=style&index=0&id=2abf9333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf9333",
  null
  
)

export default component.exports